import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { FullScreenLoader } from '@/components/layout/FullScreenLoader';
import { useAuth } from '@/features/auth/auth-context';
import { SignInScreen } from '@/features/auth/SignInScreen';

export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
});

function SignInPage() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && user) {
      void navigate({ to: '/', replace: true });
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return <FullScreenLoader label="Loading…" />;
  }

  if (user) {
    return <FullScreenLoader label="Redirecting…" />;
  }

  return <SignInScreen />;
}
